import Plugin from 'src/plugin-system/plugin.class';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class LKWLichterPlugin extends Plugin {

    init() {
        gsap.registerPlugin(ScrollTrigger);

        let tl = gsap.timeline({
            scrollTrigger: {
              trigger: this.el,
              start: "top 50%",
              end: "bottom 40%",
              scrub: 1,
              //markers: true
            }
        });
        
        tl.to('.lkw-lichter-widget img[data-step="1"]', { opacity: 1 });
        tl.to('.lkw-lichter-widget img[data-step="2"]', { opacity: 1 });
        tl.to('.lkw-lichter-widget img[data-step="3"]', { opacity: 1 });
    }

}